import ActiveRecordResource from './ActiveRecordResource';
import config from 'config';
import {LiveImageDTO, LiveImage} from "./image";

export class ParticipantImageDTO extends LiveImageDTO {
  thumbnail: string;
}

export class ParticipantImage extends LiveImage {
  protected _thumbnail: string;

  get thumbnail(): string {
    return this.isSaved ? this._thumbnail : this.url;
  }

  constructor(data: ParticipantImageDTO) {
    super(data);
    this._thumbnail = data.thumbnail;
  }
}

export default class Participant extends ActiveRecordResource {
  public name: string;
  public logo: ParticipantImage;

  static path = `${config.backOfficeBasePath}/participants`;

  static validateConstraints = {
    name: {
      presence: true
    },
    logo: {
      presence: {message: '^Please upload an image'}
    }
  };

  static mapRecords(data) {
    return data.map((item) => {
      let res =  new Participant();
      return res._parseData(item);
    });
  }

  _getModel() {
    return Participant;
  }

  _parseData(data) {
    return {
      id: data.id,
      name: data.name,
      logo: data.logo
        ? new ParticipantImage(Object.assign(new ParticipantImageDTO(), data.logo))
        : undefined
    };
  }

  prepareForSave() {
    let { name, logo } = this;

    return {
      name,
      file: logo && logo instanceof LiveImage ? logo.file : undefined
    };
  }

}



// WEBPACK FOOTER //
// ./src/api/participant.ts